import LanguageLocales from '@helsenorge/core-utils/constants/languages';

// FIXME: FLYTT TIL CORE
export const mapLanguageLocaleToCultureName = (languageLocale: LanguageLocales | undefined): string | undefined => {
  if (!languageLocale) {
    return undefined;
  }

  switch (languageLocale) {
    case LanguageLocales.NORWEGIAN:
      return 'no';
    case LanguageLocales.NORWEGIAN_NYNORSK:
      return 'nn';
    case LanguageLocales.ENGLISH:
      return 'en';
    case LanguageLocales.LITHUANIAN:
      return 'lt';
    case LanguageLocales.POLISH:
      return 'pl';
    case LanguageLocales.RUSSIAN:
      return 'ru';
    case LanguageLocales.ROMANIAN:
      return 'ro';
    case LanguageLocales.SAMI_NORTHERN:
      return 'se';
    default:
      return undefined;
  }
};
